

import "./App.css"; // Import the CSS file for styling
import React, { useState } from "react";
import "./Contact.css";

const Contact = () => {
  
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://www.legalexpertsindia.in/api/send-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      if (data.success) {
        alert("✅ Email sent successfully!");
        setFormData({ name: "", email: "", message: "" });
      } else {
        alert("❌ Failed to send email.");
      }
    } catch (error) {
      console.error(error);
      alert("Error sending email.");
    }
  };

  return (
  

  <><img src="/contact.jpg" alt="Header" />
  <div className="contact-form-container">
  <form className="contact-form" onSubmit={handleSubmit}>
  <h2>Contact Us</h2>
  <p>We’d love to hear from you!</p>

  <div className="form-group">
    <label>Full Name *</label>
    <input
      name="name"
      type="text"
      placeholder="Your name"
      value={formData.name}
      onChange={handleChange}
      required
    />
  </div>

  <div className="form-group">
    <label>Email Address *</label>
    <input
      name="email"
      type="email"
      placeholder="Your email"
      value={formData.email}
      onChange={handleChange}
      required
    />
  </div>

  <div className="form-group">
    <label>Message *</label>
    <textarea
      name="message"
      placeholder="Write your message"
      value={formData.message}
      onChange={handleChange}
      required
    />
  </div>

  <button type="submit">Send Message</button>
</form>
<div className="links-container">
          <div className="links-box">
            <h3>Office - anishsrivastava01@gmail.com</h3>
            <p className="address-black">
              S-1, Block-2, Gopal Tirath Plaza, Indira Nagar
            </p>
            <p className="address-black">
              Metro Station, Lucknow, Uttar Pradesh - 226016
            </p> 
          <div className="map-container">
          <iframe
            title="Office Location"
            src="https://maps.google.com/maps?q=Indira+Nagar+Metro+Station+Lucknow&t=&z=15&ie=UTF8&iwloc=&output=embed"
            width="100%"
            height="300"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
          </div>
     
          <div className="links-box">
            <h3>Chamber - legalexpertsindia.in@gmail.com</h3>
            <p className="address-black">
              Chamber No. E 105, Lawyers Chamber, E Block
            </p>
            <p className="address-black">
              High Court Campus, Gomtinagar, Lucknow , Contact: +91 9415425437
            </p>

          <div className="map-container">
        <iframe
          title="Chamber Location"
          src="https://www.google.com/maps?q=Lucknow+High+Court+Gomti+Nagar&output=embed"
          width="100%"
          height="350"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
          </div>
          </div>
        </div>

  </div>
  
  </>
  );
};

export default Contact;
